var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.polling)?_c('install-instructions',{attrs:{"imei":_vm.imei},on:{"next":_vm.start_polling}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }